import { Button } from "primereact/button";
import { Chip } from "primereact/chip";
import { Sidebar } from "primereact/sidebar";
import { useEffect, useState } from "react";

export default function({ children, model, onFilter }) {

    const [ open, setOpen ] = useState(false);
    const [ appliedFilters, setAppliedFilters ] = useState(model);
    const filterArray = Object.keys(appliedFilters).map(id => ({ id, ...appliedFilters[id] }));

    useEffect(() => {
        onFilter({ params: extractParams(appliedFilters), model: appliedFilters });
    }, [appliedFilters]);

    const filter = e => {
        e.preventDefault();
        setAppliedFilters(model);
        setOpen(false);
    }

    const remove = (id) => {
        let value = { ...appliedFilters };
        delete value[id];
        setAppliedFilters(value);
    }

    const chips = filterArray.filter(m => !!m.value).map(m => (
        <Chip key={m.id} label={`${m.name}: ${m.value}`} removable className="ml-2" onRemove={() => remove(m.id)}/> 
    ));

    return (
        <>
            <div className="flex">
                <Button icon="pi pi-filter-fill" label="Filtros" outlined onClick={() => setOpen(true)}/>
                <div className="md:flex align-items-center ml-2 hidden">
                    {chips}
                </div>
            </div>
            <Sidebar visible={open} position="right" onHide={() => setOpen(false)}>
                <h2>Filtros</h2>
                <form onSubmit={filter}>
                    {children}
                    <div className="formgrid grid">
                        <div className="field w-full">
                            <Button
                                label="Filtrar" 
                                className="w-full"/>
                        </div>
                    </div>
                </form>
            </Sidebar>
        </>
    );
}

export const extractParams = (filters) => {
    const filterArray = Object.values(filters);
    const hasFilters = !!filterArray.filter(m => !!m.value).length;
    if (!hasFilters) {
        return [];
    }
    const result = filterArray.filter(m => !!m.value).reduce((obj, item) => (obj[item.query] = item.value, obj) ,{});
    return result;
}